const storageFactory = (getStorage: () => Storage): Storage => {
    let inMemoryStorage: { [key: string]: string } = {};

    const isSupported = (): boolean => {
        try {
            const testKey = '__some_random_key_you_are_not_going_to_use__';
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    };

    const clear = (): void => {
        if (isSupported()) {
            getStorage().clear();
        } else {
            inMemoryStorage = {};
        }
    };

    const getItem = (name: string): string | null => {
        if (isSupported()) {
            return getStorage().getItem(name);
        }
        if (Object.prototype.hasOwnProperty.call(inMemoryStorage, name)) {
            return inMemoryStorage[name];
        }
        return null;
    };

    const key = (index: number): string | null => {
        if (isSupported()) {
            return getStorage().key(index);
        }
        return Object.keys(inMemoryStorage)[index] || null;
    };

    const removeItem = (name: string): void => {
        if (isSupported()) {
            getStorage().removeItem(name);
        } else {
            delete inMemoryStorage[name];
        }
    };

    const setItem = (name: string, value: string): void => {
        if (isSupported()) {
            getStorage().setItem(name, value);
        } else {
            inMemoryStorage[name] = String(value);
        }
    };

    const length = (): number => {
        if (isSupported()) {
            return getStorage().length;
        }
        return Object.keys(inMemoryStorage).length;
    };

    return {
        getItem,
        setItem,
        removeItem,
        clear,
        key,
        get length() {
            return length();
        },
    };
};

export const local = storageFactory(() => localStorage);
